import React from "react";
import { Typography, useTheme } from "@mui/material";
import { EditableField, InlineFieldEdit } from "../MenuBar/EditableField/EditableField";

type P = {
  subject: string;
  onEditSubject?: (value: string) => Promise<any>;
  /** Caller decides upcoming vs admin past/running (#1577). */
  isEditable: boolean;
};

export const ScheduleEventBookingSubject: React.FC<P> = ({
  subject,
  onEditSubject,
  isEditable
}) => {
  const theme = useTheme();
  const [subjectField, setSubjectField] = React.useState<InlineFieldEdit>({
    isEditing: false,
    valueBefore: subject || "",
    value: subject || ""
  });

  return (
    <>
      {isEditable ? (
        <EditableField
          state={subjectField}
          setState={setSubjectField}
          onEdit={onEditSubject}
          typographySxProps={{
            fontSize: "16px",
            color: theme.palette.text.primary,
            fontWeight: 400,
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
          data-testid="SubjectField"
        />
      ) : (
        <Typography>{subject}</Typography>
      )}
    </>
  );
};
